import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    backdrop: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        zIndex: theme.zIndex.drawer + 1
    },
}));

export const LoadingComponent = ({ show }) => {
    const classes = useStyles();

    return (
        <Backdrop className={classes.backdrop} open={show || false}>
            <CircularProgress />
        </Backdrop>
    );
};
